import {ChangeDetectionStrategy, Component, computed, inject} from '@angular/core';
import {WindowSizeService} from '../../../../services/window-size.service';

@Component({
  selector: 'app-search-widget-v3-placeholder',
  templateUrl: './search-widget-v3-placeholder.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    class: 'block w-full',
  },
})
export class SearchWidgetV3PlaceholderComponent {
  private readonly defaultMobileTopSearchSpacerHeight: number = 117;
  private readonly defaultDesktopTopSearchSpacerHeight: number = 64;
  topSearchSpacerHeight = computed<number>(() =>
    this.isMobile() ? this.defaultMobileTopSearchSpacerHeight : this.defaultDesktopTopSearchSpacerHeight,
  );
  private readonly mobileTreshold: number = 768;
  private windowSizeService = inject(WindowSizeService);
  private size = this.windowSizeService.windowSize;
  isMobile = computed<boolean>(() => this.size() && this.size()[0] < this.mobileTreshold);
}
